import { post } from '../base';

export const useModifyCurrency = () => {
  return (currency) => post('/currency', { currency });
};
